import { TOKEN_DATA_TYPE } from "enum/enums";
import { API_END_POINTS } from "lib/Constants";
import UseApiService from "./apiService";

class WebhookService {
	getWebhookList(tenantId: string) {
		const body = {
			url: `/tenants/${tenantId}${API_END_POINTS.WEBHOOK.webhooks}`,
			headerToken: TOKEN_DATA_TYPE.ACCESS,
		};
		return UseApiService().get(body);
	}
	registerWebhook({ tenantId, webhookUrl, events, description="" }: { tenantId: string; webhookUrl: string; events: string[]; description?: string }) {
		const body = {
			url: `/tenants/${tenantId}${API_END_POINTS.WEBHOOK.webhooks}`,
			headerToken: TOKEN_DATA_TYPE.ACCESS,
			data: {
				webhookUrl,
				events,
				description,
			},
		};
		return UseApiService().post(body);
	}
	getWebhookDetails({ tenantId, webhookId }: { tenantId: string; webhookId: string }) {
		const body = {
			url: `/tenants/${tenantId}/webhooks/${webhookId}`,
			headerToken: TOKEN_DATA_TYPE.ACCESS,
		};
        return UseApiService().get(body)
	}
	getWebhookEvents(tenantId:string) {
		const body = {
			url: `/tenants/${tenantId}/${API_END_POINTS.WEBHOOK.webhookEvents}`,
			headerToken: TOKEN_DATA_TYPE.ACCESS,
		};
        return UseApiService().get(body)
	}
	updateWebhook({ tenantId, webhookId,data }: { tenantId: string; webhookId: string,data:Record<string,any> }){
		const body = {
			url: `/tenants/${tenantId}/webhooks/${webhookId}`,
			headerToken: TOKEN_DATA_TYPE.ACCESS,
			data
		};
        return UseApiService().put(body)
	}
	deleteWebhook({ tenantId, webhookId }: { tenantId: string; webhookId: string }){
		const body = {
			url: `/tenants/${tenantId}/webhooks/${webhookId}`,
			headerToken: TOKEN_DATA_TYPE.ACCESS
		};
        return UseApiService().delete(body)
	}
		regenerateWebhookSecret({ tenantId, webhookId }: { tenantId: string; webhookId: string}){
		const body = {
			url: `/tenants/${tenantId}/webhooks/${webhookId}`,
			headerToken: TOKEN_DATA_TYPE.ACCESS
		};
        return UseApiService().post(body)
	}
}

const webhookService = new WebhookService();
export default webhookService;
